export default __webpack_public_path__ + "static/highlight-4-mobile-f7c62680685a4251c89f4a1534909fd7.svg";